import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/LoginPromptPage.css'
import LoginLink from '../components/auth/LoginLink';
import Button from '../components/ui/Button';


export default function LoginPromptPage(){
  return (
    <div className="centered">
      <p>
        To send messages, please log in or create an account. Joining our community
        gives you access to communicate directly with photographers and much more.
      </p>
      <div style={{display:'flex', gap:12, justifyContent:'center', marginTop:12}}>
        <LoginLink />
        <Button as="link" to="/create-account" variant="primary">Create Account</Button>
      </div>
    </div>
  );
}
